const { ComponentPropsToStylePropsMap } = require("@aws-amplify/ui-react");
var generalCommonJS = require("../js/generalCommon.js")
var dashboardCommonJS = require("../js/dashboardCommon.js")

var filtradoDefault = "TotalBulkConsumption-GeneralWhFVGeneration"

exports.cargaInicialHistorico = function(){
  
    var fechaActual = new Date();
    
    var añoActual = fechaActual.getFullYear();
    var mesActual = (fechaActual.getMonth()+1);
    var diaActual = fechaActual.getDate();
    
    if (mesActual < 10){ mesActual = "0"+mesActual;	}
    if (diaActual < 10){ diaActual = "0"+diaActual;	}
    
    var fechaActualFormateada = añoActual+"-"+mesActual+"-"+diaActual;
    var fechaDesdeFormateada = añoActual+"-"+mesActual+"-"+diaActual; //Por ahora seteo datos al día actual, ya meteré rangos
    var horaDesdeFormateada = "00:00";
    var horaHastaFormateada = "23:59";

    document.getElementById("fechaDesde").value = fechaDesdeFormateada;
    document.getElementById("fechaHasta").value = fechaActualFormateada;
    document.getElementById("horaDesde").value = horaDesdeFormateada;
    document.getElementById("horaHasta").value = horaHastaFormateada;

    document.getElementById("pestañaAnalyticsDia").checked = true

    module.exports.actualizarVisibilidadNavegadorFechas()

}

exports.setearFiltradoActual = function(filtradoActual){

    //Objeto de los valores de filtrado actuales
    var objFiltradoActual = filtradoActual.split("-")

    //Borro el seteo que hubiera en ese momento    
    var objCheckboxesFiltrado =document.getElementById("listadoFiltrosAnalytics").querySelectorAll("input[type='checkbox']")    
  
    for(var y=0; y < objCheckboxesFiltrado.length; y++){        
      if(document.getElementById(objCheckboxesFiltrado[y].id) !== null){
        document.getElementById(objCheckboxesFiltrado[y].id).checked = false
      }
    }

    //Seteo sólo los filtros actuales
    for(var x=0; x < objCheckboxesFiltrado.length; x++){        
      if(objFiltradoActual.includes(objCheckboxesFiltrado[x].id)){
        document.getElementById(objCheckboxesFiltrado[x].id).checked = true
        document.getElementById(document.getElementById(objCheckboxesFiltrado[x].id).parentNode.parentNode.id).setAttribute('open','open')

      }      
    }
}

exports.actualizarVisibilidadNavegadorFechas = function(){
    
    //Actualizo la caja informativa de fechas en función de si es día o rango

    if(document.getElementById("fechaDesde").value !== document.getElementById("fechaHasta").value){ //Si es rango

      var fechaVisibleDesde = document.getElementById("fechaDesde").value.split("-")         
      fechaVisibleDesde = fechaVisibleDesde[2] + "/" + fechaVisibleDesde[1] + "/" + fechaVisibleDesde[0]

      var fechaVisibleHasta = ""

      var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
      var fechaActual = (new Date(Date.now() - tzoffset))
      var tsFechaActual = new Date(fechaActual.toISOString().split("T")[0]).getTime()
      var tsFechaHasta = new Date(document.getElementById("fechaHasta").value).getTime()
      
      fechaActual = fechaActual.toISOString().split("T")[0]   

      if(tsFechaHasta > tsFechaActual){ 
        //Eso es que no hay más resultados así que muestro como fecha hasta el día de hoy          
        fechaVisibleHasta = fechaActual.split("-")[2] + "/" + fechaActual.split("-")[1] + "/" + fechaActual.split("-")[0]
        document.getElementById("fechaHasta").value = fechaActual.split("-")[0]+"-"+fechaActual.split("-")[1]+"-"+fechaActual.split("-")[2];
      }
      else{
        fechaVisibleHasta = document.getElementById("fechaHasta").value.split("-")      
        fechaVisibleHasta = fechaVisibleHasta[2] + "/" + fechaVisibleHasta[1] + "/" + fechaVisibleHasta[0]
      }

      var elementosFechaVisibleHasta = fechaVisibleHasta.split("/")
      var fechaVisibleHastaFormatoCortoISO = elementosFechaVisibleHasta[2] + "-" + elementosFechaVisibleHasta[1] + "-" + elementosFechaVisibleHasta[0]

      if(document.getElementById("pestañaAnalyticsMes").checked === true){
          
        var nombrePestaña = dashboardCommonJS.obtenerNombreMes(parseInt(document.getElementById("fechaDesde").value.split("-")[1])) + " " + document.getElementById("fechaDesde").value.split("-")[0]
        document.getElementById("etiquetaFechaEditable").innerHTML = nombrePestaña  
        document.getElementById("etiquetaFechaNoEditable").innerHTML = nombrePestaña    

      }

      else if(document.getElementById("pestañaAnalyticsSemana").checked === true){

        if(fechaVisibleHastaFormatoCortoISO === fechaActual){              
          document.getElementById("etiquetaFechaEditable").innerHTML = "Esta semana"      
          document.getElementById("etiquetaFechaNoEditable").innerHTML = "Esta semana"                        
        }
        else{
          document.getElementById("etiquetaFechaNoEditable").innerHTML = fechaVisibleDesde + " - " + fechaVisibleHasta
          document.getElementById("etiquetaFechaEditable").innerHTML = fechaVisibleDesde + " - " + fechaVisibleHasta
        }

      }
      else{
        document.getElementById("etiquetaFechaNoEditable").innerHTML = fechaVisibleDesde + " - " + fechaVisibleHasta
        document.getElementById("etiquetaFechaEditable").innerHTML = fechaVisibleDesde + " - " + fechaVisibleHasta
      }
      
    }
    else{ // si es día
    
      var timestampfechaActual = new Date().getTime()
      var segundosDiferenciaHoraria = parseInt(new Date().getTimezoneOffset()) * 60 * 1000// milisegundos                
      var timestampFechaActualCorrecta = timestampfechaActual - segundosDiferenciaHoraria                
      var fechaActual = new Date(timestampFechaActualCorrecta).toISOString().substring(0,10)  

      var fechaVisible = document.getElementById("fechaDesde").value;          
      var elementoVisualAdaptacion = ""

      if( generalCommonJS.obtenerTipoPlataforma().includes("Web")){
        elementoVisualAdaptacion = " hidden"
      }
      else{
        elementoVisualAdaptacion = " invisible"
      }

      if(fechaActual === fechaVisible){        
        
        if(document.getElementById("pestañaAnalyticsSemana").checked === true){
          document.getElementById("etiquetaFechaEditable").innerHTML = "Esta semana"      
          document.getElementById("etiquetaFechaNoEditable").innerHTML = "Esta semana"              
        }
        else if(document.getElementById("pestañaAnalyticsMes").checked === true){
          var nombrePestaña = dashboardCommonJS.obtenerNombreMes(parseInt(document.getElementById("fechaDesde").value.split("-")[1])) + " " + document.getElementById("fechaDesde").value.split("-")[0]
          document.getElementById("etiquetaFechaEditable").innerHTML = nombrePestaña  
          document.getElementById("etiquetaFechaNoEditable").innerHTML = nombrePestaña    
        }
        else{
          document.getElementById("etiquetaFechaEditable").innerHTML = "Hoy"      
          document.getElementById("etiquetaFechaNoEditable").innerHTML = "Hoy"              
        }
        

      }
      else{
        fechaVisible = fechaVisible.split("-")
        fechaVisible = fechaVisible[2] + "/" + fechaVisible[1] + "/" + fechaVisible[0]
        document.getElementById("etiquetaFechaEditable").innerHTML = fechaVisible  
        document.getElementById("etiquetaFechaNoEditable").innerHTML = fechaVisible          
      }

    }

}

exports.actualizarGrafica = function(tipoActualizacion, setObjQueryGrafica, ReactGA){

    var fechaDesde = document.getElementById('fechaDesde').value + "T"+document.getElementById('horaDesde').value+":00"
    var fechaHasta = document.getElementById('fechaHasta').value + "T"+document.getElementById('horaHasta').value+":59"  
    var filtradoActual = ""
  
    var objCheckboxesFiltrado = document.getElementById("filtrosAnalytics").querySelectorAll("input[type='checkbox']")    

    if (tipoActualizacion === "default"){            
      setObjQueryGrafica({"fromDatetime": fechaDesde,"toDatetime": fechaHasta,"queryFilters":filtradoDefault})
    }    
    else if(tipoActualizacion === "analyticsQueryRequest"){
      var tipoPeticion = localStorage.getItem("analyticsQueryRequest").split("|")[0]
      var datosPeticion = localStorage.getItem("analyticsQueryRequest").split("|")[1]

      if(tipoPeticion === "HistoricalMaximun"){

        document.getElementById("fechaDesde").value = datosPeticion
        document.getElementById("fechaHasta").value = datosPeticion
        document.getElementById("horaDesde").value = "00:00";
        document.getElementById("horaHasta").value = "23:59";

        fechaDesde = document.getElementById('fechaDesde').value + "T"+document.getElementById('horaDesde').value+":00"
        fechaHasta = document.getElementById('fechaHasta').value + "T"+document.getElementById('horaHasta').value+":59"  

        if(JSON.parse(localStorage.getItem("lastDashboardData")).InstallationData.GeneralInfo.ElectricSystemType === "MONOFASICO"){               
          filtradoActual = "PowerContracted-GeneralWhInstallationTOTALGeneration"          
        }
        else{ //TRIFASICA                  
          filtradoActual = "PowerContracted-GeneralWhInstallationTOTALGeneration-GeneralWhInstallationGenerationP1-GeneralWhInstallationGenerationP2-GeneralWhInstallationGenerationP3"          
        }

        localStorage.removeItem("analyticsQueryRequest")      

        generalCommonJS.registrarEventoAnalitica(ReactGA, 'ANALYTICS', 'BÚSQUEDA AVANZADA - MÁXIMO HISTÓRICO', fechaDesde.split("T")[0]+" - "+fechaHasta.split("T")[0]+" : "+filtradoActual, "")

        setObjQueryGrafica({"fromDatetime": fechaDesde,"toDatetime": fechaHasta,"queryFilters": filtradoActual})        

      }      
      
    }    
    else{ // Sino es una consulta manual y recupero los valores de los filtros
           
        if(objCheckboxesFiltrado.length !== 0){

          var cadenaFiltradoTemp = ""

          for(var x=0; x < objCheckboxesFiltrado.length; x++){        
            if(document.getElementById(objCheckboxesFiltrado[x].id) !== null){
                if(document.getElementById(objCheckboxesFiltrado[x].id).checked === true){
                    cadenaFiltradoTemp += objCheckboxesFiltrado[x].id + "-"
                  }
            }            
          }      

          generalCommonJS.registrarEventoAnalitica(ReactGA, 'ANALYTICS', 'BÚSQUEDA AVANZADA', fechaDesde.split("T")[0]+" - "+fechaHasta.split("T")[0]+" : "+filtradoActual, "")

          if(cadenaFiltradoTemp === ""){
            if(tipoActualizacion === "filtros"){
              document.getElementById("divMensajeErrorFiltros").className = document.getElementById("divMensajeErrorFiltros").className.replaceAll("hidden", "")
            }
            else{
              filtradoActual = filtradoDefault
              setObjQueryGrafica({"fromDatetime": fechaDesde,"toDatetime": fechaHasta,"queryFilters":filtradoActual})
            }
          }
          else{
            filtradoActual = cadenaFiltradoTemp.substring(0, cadenaFiltradoTemp.length - 1)       

            document.getElementById("filtrosAnalytics").className += " hidden"
            document.getElementById("divMensajeErrorFiltros").className += " hidden"
            setObjQueryGrafica({"fromDatetime": fechaDesde,"toDatetime": fechaHasta,"queryFilters":filtradoActual})
          }

        }
    }

    module.exports.actualizarVisibilidadNavegadorFechas()

}

exports.navegarDatosDia = function(dia, setObjQueryGrafica, ReactGA){
  
    if(dia === "anterior"){      

      if(document.getElementById("pestañaAnalyticsDia").checked === true){

        var fechaActualVisible = document.getElementById("fechaDesde").value.split("-")        
        var nuevaFecha = module.exports.calcularNuevaFecha("restar",fechaActualVisible[2],fechaActualVisible[1],fechaActualVisible[0], 1)
        document.getElementById("fechaDesde").value = nuevaFecha
        document.getElementById("fechaHasta").value = nuevaFecha 

      }
      else if(document.getElementById("pestañaAnalyticsSemana").checked === true){
        
        var fechaDesdeActual = document.getElementById("fechaDesde").value.split("-")
        document.getElementById("fechaDesde").value = module.exports.calcularNuevaFecha("restar",fechaDesdeActual[2],fechaDesdeActual[1],fechaDesdeActual[0], 7)  
        document.getElementById("fechaHasta").value = module.exports.calcularNuevaFecha("restar",fechaDesdeActual[2],fechaDesdeActual[1],fechaDesdeActual[0], 1)  

      }
      else if(document.getElementById("pestañaAnalyticsMes").checked === true){

        var diaDesde = 1
        var mesDesde = parseInt(document.getElementById("fechaDesde").value.split("-")[1]) - 1
        var añoDesde = parseInt(document.getElementById("fechaDesde").value.split("-")[0])

        if(mesDesde < 1){ //Le he dado atrás en Enero
          mesDesde = 12
          añoDesde = añoDesde - 1
        }
        
        if (mesDesde < 10){ mesDesde = "0"+mesDesde;	}
        if (diaDesde < 10){ diaDesde = "0"+diaDesde;	}

        var fechaDesdeFormateada = añoDesde+"-"+mesDesde+"-"+diaDesde;         

        var diaHasta = new Date(añoDesde, mesDesde, 0).getDate()
        var mesHasta = parseInt(mesDesde)
        var añoHasta = añoDesde
        
        if (mesHasta < 10){ mesHasta = "0"+mesHasta;	}
        if (diaHasta < 10){ diaHasta = "0"+diaHasta;	}

        var fechaHastaFormateada = añoHasta+"-"+mesHasta+"-"+diaHasta; 
        
        document.getElementById("fechaDesde").value = fechaDesdeFormateada
        document.getElementById("fechaHasta").value = fechaHastaFormateada

      }
      else { /* Personalizado */ }
      
    }
    else{ // Siguiente

      if(document.getElementById("pestañaAnalyticsDia").checked === true){

        var fechaActualVisible = document.getElementById("fechaDesde").value.split("-")        
        var nuevaFecha = module.exports.calcularNuevaFecha("sumar",fechaActualVisible[2],fechaActualVisible[1],fechaActualVisible[0], 1)
        document.getElementById("fechaDesde").value = nuevaFecha
        document.getElementById("fechaHasta").value = nuevaFecha 

      }
      else if(document.getElementById("pestañaAnalyticsSemana").checked === true){
        
        var fechaHastaActual = document.getElementById("fechaHasta").value.split("-")
        document.getElementById("fechaDesde").value = module.exports.calcularNuevaFecha("sumar",fechaHastaActual[2],fechaHastaActual[1],fechaHastaActual[0], 1)  
        document.getElementById("fechaHasta").value = module.exports.calcularNuevaFecha("sumar",fechaHastaActual[2],fechaHastaActual[1],fechaHastaActual[0], 7)  

      }
      else if(document.getElementById("pestañaAnalyticsMes").checked === true){
        
        var diaDesde = 1
        var mesDesde = parseInt(document.getElementById("fechaDesde").value.split("-")[1]) + 1
        var añoDesde = parseInt(document.getElementById("fechaDesde").value.split("-")[0])

        if(mesDesde > 12){ //Le he dado adelante en Diciembre
          mesDesde = 1
          añoDesde = añoDesde + 1
        }
        
        if (mesDesde < 10){ mesDesde = "0"+mesDesde;	}
        if (diaDesde < 10){ diaDesde = "0"+diaDesde;	}

        var fechaDesdeFormateada = añoDesde+"-"+mesDesde+"-"+diaDesde; 

        var diaHasta = new Date(añoDesde, mesDesde, 0).getDate()
        var mesHasta = parseInt(mesDesde)
        var añoHasta = añoDesde
        
        if (mesHasta < 10){ mesHasta = "0"+mesHasta;	}
        if (diaHasta < 10){ diaHasta = "0"+diaHasta;	}

        var fechaHastaFormateada = añoHasta+"-"+mesHasta+"-"+diaHasta; 

        document.getElementById("fechaDesde").value = fechaDesdeFormateada
        document.getElementById("fechaHasta").value = fechaHastaFormateada
      }
      else { /* Personalizado */ }

    }
       
    module.exports.actualizarGrafica("filtros-consola", setObjQueryGrafica, ReactGA)
  
}

exports.calcularNuevaFecha = function(operacion, dia, mes, año, diasARestar){

  var fechaVisible = new Date(año+"-"+mes+"-"+dia)

  if(operacion === "restar"){
    fechaVisible = new Date(parseInt(fechaVisible.getTime() - (parseInt(diasARestar) * 24 * 60 * 60 * 1000)))
  }
  else{ //sumar
    fechaVisible = new Date(parseInt(fechaVisible.getTime() + (parseInt(diasARestar) * 24 * 60 * 60 * 1000)))
  }  

  var nuevoAño = fechaVisible.getFullYear();
  var nuevoMes = (fechaVisible.getMonth()+1);
  var nuevoDia = fechaVisible.getDate();

  if (nuevoMes < 10){ nuevoMes = "0"+nuevoMes;	}
  if (nuevoDia < 10){ nuevoDia = "0"+nuevoDia;	}
  
  return nuevoAño+"-"+nuevoMes+"-"+nuevoDia

}

module.exports.resetearBusquedaDatos = function(){

  document.getElementById("textoBuscadorDatosAnalytics").value = ""
  document.getElementById("divSinResultadosBusquedaFiltrosAnalytics").className = document.getElementById("divSinResultadosBusquedaFiltrosAnalytics").className.replaceAll(" hidden", "") + " hidden"  

    var objDetails = document.getElementById("filtrosAnalytics").querySelectorAll("details")    
    var idGrupoTemp = ""
    var objCheckboxesGrupoTemp = ""    
    var numeroElementosSeleccionadosTemp = 0

    for(var x=0; x < objDetails.length; x++){        
      
      idGrupoTemp = objDetails[x].id
      objCheckboxesGrupoTemp = document.getElementById(idGrupoTemp).querySelectorAll("input[type='checkbox']")                
      
      document.getElementById(objDetails[x].id).removeAttribute('open')       
      document.getElementById("botonSeleccionarTodosGrupo"+idGrupoTemp).className = document.getElementById("botonSeleccionarTodosGrupo"+idGrupoTemp).className.replaceAll(" hidden", "")

      numeroElementosSeleccionadosTemp = 0

      for(var y=0; y < objCheckboxesGrupoTemp.length; y++){             
        document.getElementById("labelDatos"+objCheckboxesGrupoTemp[y].id).className = document.getElementById("labelDatos"+objCheckboxesGrupoTemp[y].id).className.replaceAll(" hidden", "")
        if(document.getElementById(objCheckboxesGrupoTemp[y].id).checked === true){
          numeroElementosSeleccionadosTemp = numeroElementosSeleccionadosTemp + 1
        }
      }

      if(numeroElementosSeleccionadosTemp > 0){
        document.getElementById("spanSeleccionados"+idGrupoTemp).innerHTML = "[ "+numeroElementosSeleccionadosTemp+" ]"
      }
      else{
        document.getElementById("spanSeleccionados"+idGrupoTemp).innerHTML = ""
      }

      document.getElementById(idGrupoTemp).className = document.getElementById(idGrupoTemp).className.replaceAll(" hidden", "")      

    }      

}

module.exports.actualizarConteoFiltrosSinRefrescar = function(){

  try{

    var objDetails = document.getElementById("filtrosAnalytics").querySelectorAll("details")    
    var idGrupoTemp = ""
    var objCheckboxesGrupoTemp = ""    
    var numeroElementosSeleccionadosTemp = 0

    for(var x=0; x < objDetails.length; x++){        
      
      idGrupoTemp = objDetails[x].id
      objCheckboxesGrupoTemp = document.getElementById(idGrupoTemp).querySelectorAll("input[type='checkbox']")                
      
      numeroElementosSeleccionadosTemp = 0

      for(var y=0; y < objCheckboxesGrupoTemp.length; y++){                       
        if(document.getElementById(objCheckboxesGrupoTemp[y].id).checked === true){
          numeroElementosSeleccionadosTemp = numeroElementosSeleccionadosTemp + 1
        }
      }

      if(numeroElementosSeleccionadosTemp > 0){
        document.getElementById("spanSeleccionados"+idGrupoTemp).innerHTML = "[ "+numeroElementosSeleccionadosTemp+" ]"
      }
      else{
        document.getElementById("spanSeleccionados"+idGrupoTemp).innerHTML = ""
      }

    }      

  }
  catch(error){
    console.log(error)
  }

}

exports.abrirMenuFiltrado = function(modoFiltrado){     
  
    document.getElementById("filtrosAnalytics").className = document.getElementById("filtrosAnalytics").className.replaceAll("hidden","")
    document.getElementById("divMensajeErrorFiltros").className = document.getElementById("divMensajeErrorFiltros").className.replaceAll("hidden","") + " hidden"
    
    if(modoFiltrado === "Datos"){
      document.getElementById("tituloDetalleWidgetAnalytics").innerHTML = "Datos"      
      document.getElementById("formularioFechasAnalytics").className = document.getElementById("formularioFechasAnalytics").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("fieldsetTextoBuscadorDatosAnalytics").className = document.getElementById("fieldsetTextoBuscadorDatosAnalytics").className.replaceAll(" hidden", "")      
      document.getElementById("listadoFiltrosAnalytics").className = document.getElementById("listadoFiltrosAnalytics").className.replaceAll(" hidden", "")      
      document.getElementById("botonReiniciarFiltros").className = document.getElementById("botonReiniciarFiltros").className.replaceAll(" hidden", "")
      document.getElementById("fieldsetEstadoFavoritoConsulta").className = document.getElementById("fieldsetEstadoFavoritoConsulta").className.replaceAll(" hidden", "")
      module.exports.resetearBusquedaDatos()

    }
    else{ //Fechas
      document.getElementById("tituloDetalleWidgetAnalytics").innerHTML = "Rango personalizado"      
      document.getElementById("formularioFechasAnalytics").className = document.getElementById("formularioFechasAnalytics").className.replaceAll(" hidden", "")
      document.getElementById("fieldsetTextoBuscadorDatosAnalytics").className = document.getElementById("fieldsetTextoBuscadorDatosAnalytics").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("listadoFiltrosAnalytics").className = document.getElementById("listadoFiltrosAnalytics").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("botonReiniciarFiltros").className = document.getElementById("botonReiniciarFiltros").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("fieldsetEstadoFavoritoConsulta").className = document.getElementById("fieldsetEstadoFavoritoConsulta").className.replaceAll(" hidden", "") + " hidden"
    }

}

exports.obtenerUnidadAtributo = function(atributo){
			
  var unidadAtributo = "";
  
  if(atributo === "TotalMaximunGeneration"){ unidadAtributo = "W"; }
  else if(atributo ===  "TotalBulkGeneration"){ unidadAtributo = "W"; }
  else if(atributo ===  "TotalBulkConsumption"){ unidadAtributo = "W"; }
  else if(atributo ===  "TotalWastedEnergy"){ unidadAtributo = "W"; }
  else if(atributo ===  "TotalReactiveEnergy"){ unidadAtributo = "VArh"; }
  else if(atributo ===  "TotalCapacitiveEnergy"){ unidadAtributo = "VArh"; }
  else if(atributo ===  "SkyStatusValue"){ unidadAtributo = ""; }
  else if(atributo ===  "Temperature"){ unidadAtributo = "°C"; }
  else if(atributo ===  "SolarRadiation"){ unidadAtributo = "W/m²"; }
  else if(atributo ===  "UV"){ unidadAtributo = ""; }
  else if(atributo ===  "WindSpeed"){ unidadAtributo = "Km/h"; }
  else if(atributo ===  "PrecipRate"){ unidadAtributo = "L/m²"; }
  else if(atributo ===  "Humidity"){ unidadAtributo = "%"; }
  else if(atributo ===  "FVMaxGenerationEstimation"){ unidadAtributo = "W"; }
  else if(atributo ===  "FVPerformance"){ unidadAtributo = "%"; }
  else if(atributo ===  "GeneralWhFVGeneration"){ unidadAtributo = "W"; }
  else if(atributo ===  "FVWastedEnergy"){ unidadAtributo = "W"; }
  else if(atributo ===  "GeneralBatteryPercentage"){ unidadAtributo = "%"; }
  else if(atributo ===  "BatteryVoltage"){ unidadAtributo = "V"; }
  else if(atributo ===  "BatteryAmperage"){ unidadAtributo = "A"; }
  else if(atributo ===  "BatteryTemperature"){ unidadAtributo = "°C"; }
  else if(atributo ===  "BatteryWhConsumption"){ unidadAtributo = "W"; }
  else if(atributo ===  "GeneratorPerformance"){ unidadAtributo = "%"; }
  else if(atributo ===  "CurrentGeneratorTankLevel"){ unidadAtributo = "L"; }
  else if(atributo ===  "CurrentGeneratorTankPercentage"){ unidadAtributo = "%"; }
  else if(atributo ===  "CurrentGeneratorLitersConsumption"){ unidadAtributo = "L/Hr"; }
  else if(atributo ===  "CurrentGeneratorConsumptionCost"){ unidadAtributo = "€/Hr"; }
  else if(atributo ===  "GeneralWhGeneratorTOTALGeneration"){ unidadAtributo = "W"; }
  else if(atributo ===  "GeneralWhGeneratorGenerationP1"){ unidadAtributo = "W"; }
  else if(atributo ===  "GeneralWhGeneratorGenerationP2"){ unidadAtributo = "W"; }
  else if(atributo ===  "GeneralWhGeneratorGenerationP3"){ unidadAtributo = "W"; }
  else if(atributo ===  "WorkingTimeAccumulatedFromDate"){ unidadAtributo = "Hrs"; }
  else if(atributo ===  "GeneralWhInstallationTOTALConsumption"){ unidadAtributo = "W"; }
  else if(atributo ===  "GeneralWhInstallationTOTALGeneration"){ unidadAtributo = "W"; }
  else if(atributo ===  "GeneralWhInstallationTOTALWastedEnergy"){ unidadAtributo = "W"; }
  else if(atributo ===  "GeneralWhInstallationTOTALReactiveEnergy"){ unidadAtributo = "VArh"; }
  else if(atributo ===  "GeneralWhInstallationTOTALCapacitiveEnergy"){ unidadAtributo = "VArh"; }
  else if(atributo ===  "GeneralWhInstallationGenerationP1"){ unidadAtributo = "W"; }
  else if(atributo ===  "GeneralWhInstallationGenerationP2"){ unidadAtributo = "W"; }
  else if(atributo ===  "GeneralWhInstallationGenerationP3"){ unidadAtributo = "W"; }
  else if(atributo ===  "GeneralWhInstallationConsumptionP1"){ unidadAtributo = "W"; }
  else if(atributo ===  "GeneralWhInstallationConsumptionP2"){ unidadAtributo = "W"; }
  else if(atributo ===  "GeneralWhInstallationConsumptionP3"){ unidadAtributo = "W"; }
  else if(atributo ===  "GeneralWhInstallationWastedEnergyP1"){ unidadAtributo = "W"; }
  else if(atributo ===  "GeneralWhInstallationWastedEnergyP2"){ unidadAtributo = "W"; }
  else if(atributo ===  "GeneralWhInstallationWastedEnergyP3"){ unidadAtributo = "W"; }
  else if(atributo ===  "GeneralWhInstallationReactiveEnergyP1"){ unidadAtributo = "VArh"; }
  else if(atributo ===  "GeneralWhInstallationReactiveEnergyP2"){ unidadAtributo = "VArh"; }
  else if(atributo ===  "GeneralWhInstallationReactiveEnergyP3"){ unidadAtributo = "VArh"; }
  else if(atributo ===  "GeneralWhInstallationCapacitiveEnergyP1"){ unidadAtributo = "VArh"; }
  else if(atributo ===  "GeneralWhInstallationCapacitiveEnergyP2"){ unidadAtributo = "VArh"; }
  else if(atributo ===  "GeneralWhInstallationCapacitiveEnergyP3"){ unidadAtributo = "VArh"; }
  else if(atributo ===  "ChargeLevel"){ unidadAtributo = "%"; }
  else if(atributo ===  "Autonomy"){ unidadAtributo = "Kms"; }
  else if(atributo ===  "ChargePower"){ unidadAtributo = "kW"; }
  else if(atributo ===  "ChargeVoltage"){ unidadAtributo = "V"; }
  else if(atributo ===  "ChargeAmperage"){ unidadAtributo = "A"; }
  else if(atributo ===  "TodayEnergeticUse"){ unidadAtributo = "%"; }
  else if(atributo ===  "TodayTotalGeneration"){ unidadAtributo = "W"; }
  else if(atributo ===  "TodayselfConsumption"){ unidadAtributo = "%"; }
  else if(atributo ===  "TodayfromGrid"){ unidadAtributo = "W"; }
  else if(atributo ===  "Todayconsumption"){ unidadAtributo = "W"; }
  else if(atributo ===  "TodaytoGrid"){ unidadAtributo = "W"; }
  else if(atributo ===  "TodaysavingsBalance"){ unidadAtributo = "€"; }
  else if(atributo ===  "TodayenergyWaste"){ unidadAtributo = "€"; }
  else if(atributo ===  "TodayusedEnergyCost"){ unidadAtributo = "€"; }
  else if(atributo ===  "TodayenergyRevenue"){ unidadAtributo = "€"; }
  else if(atributo ===  "TodayGivenAwayMoney"){ unidadAtributo = "€"; }
  else if(atributo ===  "TodayPercentageReactive"){ unidadAtributo = "%"; }
  else if(atributo ===  "TodayTotalReactive"){ unidadAtributo = "VArh"; }
  else if(atributo ===  "CurrentMonthEnergeticUse"){ unidadAtributo = "%"; }
  else if(atributo ===  "CurrentMonthTotalGeneration"){ unidadAtributo = "W"; }
  else if(atributo ===  "CurrentMonthselfConsumption"){ unidadAtributo = "%"; }
  else if(atributo ===  "CurrentMonthfromGrid"){ unidadAtributo = "W"; }
  else if(atributo ===  "CurrentMonthconsumption"){ unidadAtributo = "W"; }
  else if(atributo ===  "CurrentMonthtoGrid"){ unidadAtributo = "W"; }
  else if(atributo ===  "CurrentMonthsavingsBalance"){ unidadAtributo = "€"; }
  else if(atributo ===  "CurrentMonthenergyWaste"){ unidadAtributo = "€"; }
  else if(atributo ===  "CurrentMonthusedEnergyCost"){ unidadAtributo = "€"; }
  else if(atributo ===  "CurrentMonthenergyRevenue"){ unidadAtributo = "€"; }
  else if(atributo ===  "CurrentMonthGivenAwayMoney"){ unidadAtributo = "€"; }
  else if(atributo ===  "CurrentMonthPercentageReactive"){ unidadAtributo = "%"; }
  else if(atributo ===  "CurrentMonthTotalReactive"){ unidadAtributo = "VArh"; }
  else if(atributo ===  "YearEnergeticUse"){ unidadAtributo = "%"; }
  else if(atributo ===  "YearTotalGeneration"){ unidadAtributo = "W"; }
  else if(atributo ===  "YearselfConsumption"){ unidadAtributo = "%"; }
  else if(atributo ===  "YearfromGrid"){ unidadAtributo = "W"; }
  else if(atributo ===  "Yearconsumption"){ unidadAtributo = "W"; }
  else if(atributo ===  "YeartoGrid"){ unidadAtributo = "W"; }
  else if(atributo ===  "YearsavingsBalance"){ unidadAtributo = "€"; }
  else if(atributo ===  "YearenergyWaste"){ unidadAtributo = "€"; }
  else if(atributo ===  "YearusedEnergyCost"){ unidadAtributo = "€"; }
  else if(atributo ===  "YearenergyRevenue"){ unidadAtributo = "€"; }
  else if(atributo ===  "YearPercentageReactive"){ unidadAtributo = "%"; }
  else if(atributo ===  "YearTotalReactive"){ unidadAtributo = "VArh"; }
  else if(atributo ===  "SinceRegistrationEnergeticUse"){ unidadAtributo = "%"; }
  else if(atributo ===  "SinceRegistrationTotalGeneration"){ unidadAtributo = "W"; }
  else if(atributo ===  "SinceRegistrationselfConsumption"){ unidadAtributo = "%"; }
  else if(atributo ===  "SinceRegistrationfromGrid"){ unidadAtributo = "W"; }
  else if(atributo ===  "SinceRegistrationconsumption"){ unidadAtributo = "W"; }
  else if(atributo ===  "SinceRegistrationtoGrid"){ unidadAtributo = "W"; }
  else if(atributo ===  "SinceRegistrationsavingsBalance"){ unidadAtributo = "€"; }
  else if(atributo ===  "SinceRegistrationenergyWaste"){ unidadAtributo = "€"; }
  else if(atributo ===  "SinceRegistrationusedEnergyCost"){ unidadAtributo = "€"; }
  else if(atributo ===  "SinceRegistrationenergyRevenue"){ unidadAtributo = "€"; }
  else if(atributo ===  "SinceRegistrationPercentageReactive"){ unidadAtributo = "%"; }
  else if(atributo ===  "TodayTotalRSinceRegistrationTotalReactiveeactive"){ unidadAtributo = "VArh"; }
  else if(atributo ===  "HistoricalMaxPowerConsumption"){ unidadAtributo = "W"; }
  else if(atributo ===  "EnergyBuyPrice"){ unidadAtributo = "€/kWh"; }  
  else if(atributo ===  "MarketAverageBuyPrice"){ unidadAtributo = "€/kWh"; }  
  else if(atributo ===  "DailyEnergySellPrice"){ unidadAtributo = "€/kWh"; }  
  else if(atributo ===  "EnergySellPrice"){ unidadAtributo = "€/kWh"; }    
  else if(atributo ===  "DailyAverageBuyPrice"){ unidadAtributo = "€/kWh"; }  
  else if(atributo ===  "DailyAverageSellPrice"){ unidadAtributo = "€/kWh"; }  
  else if(atributo ===  "DailyAverageSellPriceDaylight"){ unidadAtributo = "€/kWh"; }  
  else if(atributo ===  "TodayPersonalAverageBuyPrice"){ unidadAtributo = "€/kWh"; }  
  else if(atributo ===  "TodayPersonalAverageSellPrice"){ unidadAtributo = "€/kWh"; }  
  else if(atributo ===  "TodayselfConsumptionBalance"){ unidadAtributo = "€"; }
  else if(atributo ===  "CurrentMonthselfConsumptionBalance"){ unidadAtributo = "€"; }
  else if(atributo ===  "YearselfConsumptionBalance"){ unidadAtributo = "€"; }
  else if(atributo ===  "SinceRegistrationselfConsumptionBalance"){ unidadAtributo = "€"; }
  else if(atributo ===  "CurrentSolarWalletBalance"){ unidadAtributo = "€"; }
  else if(atributo ===  "PreviousMonthsSolarWalletBalance"){ unidadAtributo = "€"; }

  return unidadAtributo;
}